/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MedalIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACFElEQVR4nN1UO2tUURC+BlEhqL0voj9AC4UoRrYKXNg7jxs4d+YmkVVELXyBYpHq/oEIkZDSvyAxiVUqNYWt2toF7TSCryJB5Zw9dzW79yTZ3coMTLE738x355s5E0W7xohEgPQTsv4uHVjeAujpUE49zc4g6bt/c5DlM7BmHWBgXd4M9CSk72uNxoF2vP3PxipzWJc7CDDVW1VgbHrRgWctgvhU73YQFEUxACyvA138qI+NnyqxSWJOIOv3agJ5U6vV9lZqyjx+Fkg3qtuWhZacJE8CH7KBqOdCM/PJOhNqHVgSP69GgGBmy+JOW8SDQLK6zcD3IMmrzTFZtbnbEjRJNG0r/AVYniLLNKIeaa0o63qJSSjnHRVvScXyDEl+IsvD0dHJwQDmhsOQzkfdmjHmMIA56baL5AqSriDLN+ekK3YONkYkQ3E8cSjqxeI43o+ki1sMfcFiol4NWebK54+s163+1q00wLLmh/u4p+JEcty/iXVEHUaWe0Dysel6B9LsfBlP04ljXRMAyTX/hUtEcqlNnl8J5yPA8tz9xuxq9wSsU16eaSB9UHES7gPpI3/cpvrqIOF8pL0DGMsu9tWBnYHV19+XYac7ywfvtxPOL5QzqNfN0agXQ9JZv45r7lH5LSLKb/7doh3cn5DZHXcvOnT3SeeNMfuifqwoioGE5DKwvgTSr85ZXwDrpI31Vfy/sD+dw6QJMbY5eAAAAABJRU5ErkJggg==)
 */
export const MedalIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.34 11.06c-.18.28-.56.32-.8.1-.34-.28-.7-.53-1.08-.75a.52.52 0 0 1-.19-.18l-1.95-3.25a.5.5 0 0 1 0-.51l2.1-3.5A2 2 0 0 1 17.13 2h3.16a1.5 1.5 0 0 1 1.28 2.3l-4.23 6.76ZM3.7 2h3.17a2 2 0 0 1 1.71.97L12 8.67l.25.41c.1.18-.03.42-.25.42-1.73 0-3.31.63-4.54 1.67-.24.2-.62.17-.8-.1L2.43 4.28C1.81 3.3 2.53 2 3.71 2ZM12 19a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 22a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
